/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app;

(function () {
  'use strict';

  /**
   * Вид для показа категорий внизу страницы.
   * @param {Function} applyFilterOnClick Применяет фильтр в родительском виде.
   */
  app.Filters.BottomTreeFilterView = app.View.extend({
    additionalOptions: ['applyFilterOnClick'],
    events: {
      'click .js-category-filter': 'applyFilter',
    },

    /** @inheritDoc */
    run: function () {
      this.isElHide = true;
      this.template = app.helpers.TemplateHelper.getTemplate('#bottom-tree-filter-template');
      this.listenTo(this.collection, 'sync', this.setViewVisibility);
    },

    /**
     * Устанавливает признак показа вида.
     * @param {app.ItemPageableCollection} collection Новая коллекция товаров.
     * @param {Object} resp Данные ответа.
     */
    setViewVisibility: function (collection, resp) {
      var newIsElHide = !_.get(resp, '_meta.showCategorySelector', false);
      if (this.isElHide !== newIsElHide) {
        this.isElHide = newIsElHide;
        this.render();
      }
    },

    /**
     * Обновляет текущую модель и делает перерисовку.
     * @param {app.Model} newModel Новая модель.
     */
    setModel: function(newModel) {
      this.model = newModel;
      if (newModel) {
        this.render();
      }
    },

    /**
     * Применяет выбранный фильтр.
     * @param {Event} e Событие при клике.
     */
    applyFilter: function (e) {
      window.scrollTo(0, 0);
      var clickedCategoryId = $(e.currentTarget).data('id');
      this.model.get('mas').forEach(function (model) {
        if (model.get('object').id === clickedCategoryId) {
          model.set('click', true);
          this.applyFilterOnClick(e);
        }
      }.bind(this));
    },

    /** @inheritDoc */
    render: function () {
      if (!this.$el.length) {
        return;
      }
      var categories = this.model.get('object').values;
      this.$el.toggleClass('not_display', this.isElHide);
      this.$('.js-bottom-tree-list').html(this.template({
        categories: categories,
      }));
    },
  });
})(jQuery);

}.call(window));